import { useSelector } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

// Orders are server-paginated newest-first, so the header is display-only (no
// client-side sort that would only reorder the current page).
const rows = [
    { id: 'orderNumber', disablePadding: true, label: 'Order #' },
    { id: 'email', disablePadding: false, label: 'Customer' },
    { id: 'source', disablePadding: false, label: 'Source' },
    { id: 'total', disablePadding: false, label: 'Total' },
    { id: 'status', disablePadding: false, label: 'Status' },
    { id: 'items', disablePadding: false, label: 'Items' },
    { id: 'date', disablePadding: false, label: 'Date' },
];

const MatTableHead = () => {
    const rtl = useSelector((state: { rtl: { direction: string } }) => state.rtl);

    return (
        <TableHead>
            <TableRow>
                {rows.map((row) => (
                    <TableCell key={row.id} align={rtl.direction === 'rtl' ? 'right' : 'left'} padding={row.disablePadding ? 'none' : 'normal'}>
                        {row.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default MatTableHead;
